/**
 * Gigglz Cart BFCache Refresh
 * Ensures cart re-renders correctly when returning
 * from /pages/personalise via browser Back button.
 */
(function () {
  function handlePageShow(event) {
    // True when restored from back/forward cache
    const persisted = event && event.persisted;

    // Some browsers don't set persisted reliably
    const navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    const isBackForward = navEntries && navEntries[0] && navEntries[0].type === 'back_forward';

    if (persisted || isBackForward) {
      // Force a reload so cart liquid + JS rerun
      window.location.reload();
    }
  }

  window.addEventListener('pageshow', handlePageShow);
})();